import React, { FC, Suspense } from 'react'
import { Loading, TitleController } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { QuestionForm } from './QuestionForm'
import { QuestionSuccess } from './QuestionSuccess'
import { QuestionDataLoader } from './QuestionDataLoader'
import {
  SidebarInfoSection,
  SidebarInfoSectionText,
  View,
} from '../../components'
import { useContractPaths } from '../../hooks/useContractPaths/useContractPaths'
import routePath from '../../router/routePath'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

export type QuestionViewState = 'form' | 'preview' | 'success'

export const Question: FC = () => {
  const [view, setView] = React.useState<QuestionViewState>('form')
  const { t } = useTranslation(['common', 'question', 'titles'])
  const { frontPagePath } = useContractPaths()
  const location = useLocation()
  const locationState = location.state as { from: string } | null
  const { currentContractId } = useCurrentContract()

  const backPath =
    locationState?.from === 'contact'
      ? routePath.contactInfo.replace(':contractId', currentContractId)
      : frontPagePath

  const backText =
    locationState?.from === 'contact'
      ? t('titles:contactInformation')
      : t('common:views.home')

  return (
    <TitleController title={t('question:headings.question')}>
      <View>
        <View.Header>
          <View.HeaderLink to={backPath}>{backText}</View.HeaderLink>
          <View.HeaderTitle>{t('question:headings.question')}</View.HeaderTitle>
        </View.Header>
        <View.Sidebar>
          <SidebarInfoSection>
            <SidebarInfoSectionText>
              {t('question:texts.instructions')}
            </SidebarInfoSectionText>
          </SidebarInfoSection>
        </View.Sidebar>
        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <QuestionDataLoader>
              {({ contract, user, userMetadata }) =>
                view === 'success' ? (
                  <QuestionSuccess />
                ) : (
                  <QuestionForm
                    contract={contract}
                    user={user}
                    userMetadata={userMetadata}
                    view={view}
                    setView={setView}
                  />
                )
              }
            </QuestionDataLoader>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
